import React from "react";
import "../css/FeaturesSectionNew.css";

import connectSecurely from "../assets/Connect securely.gif";
import birdEyeView from "../assets/Birds eye view.gif";
import stocksBondsDividends from "../assets/Supports Stcoks, Options.gif";
import taxInsights from "../assets/Insights.gif";
import notifications from "../assets/Notification.gif";
import recommendations from "../assets/Recommendation.gif";

function FeaturesSectionNew() {
  const features = [
    {
      title: "Connect securely with major brokerages",
      icon: connectSecurely,
    },
    {
      title: "Bird's-eye view of your entire portfolio",
      icon: birdEyeView,
    },
    {
      title: "Supports stocks, bonds, options, dividends, and interest",
      icon: stocksBondsDividends,
    },
    {
      title: "Tax-conscious insights before you buy or sell",
      icon: taxInsights,
    },
    {
      title: "Personalized savings and smart loss-harvest alerts",
      icon: notifications,
    },
    {
      title: "Tax-smart reinvestment recommendations",
      icon: recommendations,
    },
  ];

  return (
    <section className="features-section">
      <div className="content-wrapper">
        <h2>
          FEATURES <span>that puts you in control...</span>
        </h2>
        <div className="features-container">
          {features.map((feature, index) => (
            <div key={index} className="feature-item">
              <div className="feature-image">
                <img src={feature.icon} />
              </div>
              <div className="feature-text">
                <h4>{feature.title}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturesSectionNew;
